import { render, staticRenderFns } from "./ModalInner.vue?vue&type=template&id=a2072ca2"
import script from "./ModalInner.vue?vue&type=script&lang=js"
export * from "./ModalInner.vue?vue&type=script&lang=js"
import style0 from "./ModalInner.vue?vue&type=style&index=0&id=a2072ca2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports